module.exports = __webpack_public_path__ + "static/media/GAS.8d0e3835.svg";